import styled from 'styled-components/macro';
import { colors as Colors } from 'constants/colors';
import fonts from 'style/fonts/fonts';
import { Title2 } from 'components/text';
import { SmallText, MediumText } from 'components/text';
import { zIndex } from 'constants/settings';
import chevron from 'images/chevron.svg';
import { media } from 'style/media';
import { NavigationLink } from 'features/Navigation';

export const MainContentDiv = styled.div.attrs(props => ({}))`
  height: 100%;
  max-width: 100%;
  @media (min-width: 993px) {
    min-width: ${({ hasrelated }) => (hasrelated ? '78%' : '100%')};
  }
  @media (max-width: 992px) {
    min-width: 100%;
  }
`;

export const SubMenuContainerDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  height: 3.75rem;
  width: 100%;
  background-color: #f7f8f9;
`;

export const SubMenuContainerItem = styled.div`
  width: 220px;
  white-space: normal;
  word-break: break-word;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
`;

export const SubMenuContainerLink = styled(NavigationLink)`
  color: ${Colors.BLACK};
  font-family: ${fonts.LLBrown.REGULAR};
  text-decoration: none !important;
  text-align: center;
  letter-spacing: 0px;
  font-size: 0.7rem;
`;

export const Underlined = styled.div`
  position: relative;
  bottom: -0.5rem;
  background-color: ${Colors.ORANGE};
  height: 3px;
`;

export const LeftMenuContainerDiv = styled.div`
  display: flex;
  max-width: 11rem;
  align-content: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;

export const LeftMenuContainerUl = styled.ul`
  padding: 0;
`;

export const LeftMenuContainerLi = styled.li`
  align-self: center;
  list-style-type: none;
`;

export const LeftMenuContainerLiUnderline = styled.div`
  border: 0;
  background-color: var(--black);
  height: 1px;
  width: 11rem;
`;

export const MobileMenuContainerLiUnderline = styled.div`
  border: 0;
  background-color: ${Colors.BLACK};
  height: 1px;
  width: 85%;
`;

export const CustomLink = styled(NavigationLink)`
  color: ${Colors.BLACK};
  font-family: ${fonts.LLBrown.REGULAR};
  text-decoration: none !important;
  letter-spacing: 0px;
  font-size: 0.75rem;
`;

export const SubMenuPageTitle1 = styled(Title2)`
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.4rem;
  letter-spacing: 0;
`;

export const SubMenuPageTitle2 = styled(Title2)`
  font-size: 0.75rem;
  letter-spacing: 0;
`;

export const SubMenuPageTitle3 = styled(Title2)`
  font-size: 0.6rem;
  letter-spacing: 0;
`;

export const SubMenuPageTitleLink = styled(NavigationLink)`
  text-decoration: none !important;
  max-width: 80%;
  letter-spacing: 0px;
  font-size: 0.7rem;
`;

export const SubMenuTopTitle = styled(SmallText)`
  font-size: 0.7rem;
  padding: 0;
  margin: 0;
  letter-spacing: 0;
`;

export const SubMenuPageSmallText = styled(SmallText)`
  font-size: 0.75rem;
  letter-spacing: 0;
`;

export const SubMenuPageTitleUnderline = styled.div`
  border: 0;
  background-color: ${Colors.ORANGE};
  height: 2px;
  width: 11rem;
`;

export const RowLeft = styled.div`
  display: flex;
`;

export const ColumnLeft = styled.div.attrs(props => ({}))`
  flex: ${({ hasMenuBlock }) => (hasMenuBlock ? '35%' : '80%')};
`;

export const ColumnRight = styled.div.attrs(props => ({}))`
  flex: 65%;
`;

export const LinkButton = styled.div`
  display: inline-block;
  margin: 0.2rem 0.6rem;
  padding: ${props => (props.modal ? `0.45rem 1.05rem` : `0.55rem 1.2rem`)};
  background-color: ${props => (props.modal ? Colors.WHITE : Colors.ORANGE)};
  ${props => props.modal && `color: ${Colors.BLACK}`};
  ${props => props.modal && `border: solid 2px ${Colors.ORANGE}`};
  ${props => props.modal && `border-radius: 4px;`};
  :hover {
    cursor: pointer;
  }
  ${media.phone`
  padding: ${props => (props.modal ? `0.4rem 1rem` : `0.55rem 1.2rem`)};
  `}
`;

export const LinkButtonText = styled(MediumText).attrs(props => ({
  modal: props.modal
}))`
  font-size: 0.8rem;
  text-decoration: none;
  letter-spacing: 0;
  padding: 0;
  margin: 0;
  color: ${props => (props.modal ? Colors.BLACK : Colors.WHITE)};
  :hover {
    cursor: pointer;
  }
`;

export const CollapsibleOuterDiv = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
  padding-left: 1rem;
  height: 4rem;
  background-color: ${Colors.GRAY};
  :hover {
    cursor: pointer;
  }
`;

export const CollapsibleTwoSubOuterDiv = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
  padding-left: 10%;
  height: 4rem;
  background-color: ${Colors.WHITE};
  :hover {
    cursor: pointer;
  }
`;

export const CollapsibleInnerDiv = styled.div`
  display: table-cell;
  vertical-align: middle;
`;

export const CollapsibleInnerHeader = styled(MediumText)`
  margin: 0;
  font-size: 1.25rem;
  float: left;
  letter-spacing: 0;
`;

export const CollapsibleOuterUnderlineOrange = styled.div`
  border: 0;
  background-color: ${Colors.ORANGE};
  height: 2px;
  width: 100%;
`;

export const CollapsibleOuterUnderlineGray = styled.div`
  border: 0;
  background-color: #d4d4d4;
  float: right;
  height: 1px;
  width: 100%;
`;

export const CollapsibleInnerUnderlineGray = styled.div`
  border: 0;
  background-color: #d4d4d4;
  float: right;
  height: 1px;
  width: 90%;
`;

export const CollapsibleTwoInnerHeader = styled(MediumText)`
  margin: 0;
  font-size: 1rem;
  font-weight: 200;
  float: left;
  letter-spacing: 0;
  :hover {
    cursor: pointer;
  }
`;

export const CollapsibleTwoInnerSubHeader = styled(SmallText)`
  margin: 0;
  font-size: 0.85rem;
  font-weight: 200;
  float: left;
  letter-spacing: 0;
  :hover {
    cursor: pointer;
  }
`;

export const ArrowUp = styled.div`
  position: absolute;
  float: right;
  background: url(${chevron});
  z-index: ${zIndex.ABOVE_MODALS + 2};
  border: none;
  margin-top: 0.3rem !important;
  background-size: 1em;
  height: 1em;
  width: 1em;
  right: 1em;
`;

export const ArrowDown = styled.div`
  position: absolute;
  float: right;
  background: url(${chevron});
  transform: rotate(180deg);
  z-index: ${zIndex.ABOVE_MODALS + 2};
  border: none;
  margin-top: 0.3rem !important;
  background-size: 1em;
  height: 1em;
  width: 1em;
  right: 1em;
`;

export const ArrowLeft = styled.div`
  display: table-cell;
  vertical-align: middle;
  float: left;
  background: url(${chevron});
  transform: rotate(-90deg);
  z-index: ${zIndex.ABOVE_MODALS + 2};
  border: none;
  margin-top: 0.25em !important;
  margin-right: 0.25em;
  background-size: 0.7em;
  height: 0.7em;
  width: 0.7em;
  right: 0.7em;
`;

export const BreadcrumbsMobileStyle = styled.div`
  display: table;
  height: 2em;
  width: 100%;
  padding-left: 1em;
`;

export const BreadcrumbsMobileStyleCell = styled.div`
  display: table-cell;
  vertical-align: middle;
  width: 100%;
`;

export const BreadcrumbsMobileStyleLink = styled(CustomLink)`
  color: ${Colors.BLACK};
  font-family: ${fonts.LLBrown.REGULAR};
  font-size: 1em;
`;
